import requests   from 'helpers/requests.helper';
import RoutesAPI  from './Routes';

const OutboundAffiliatesAPI = {
  getOutboundAffiliates: () => requests.get(RoutesAPI.outbound_affiliates(), {}),
};

export default OutboundAffiliatesAPI;



// WEBPACK FOOTER //
// ./src/api/OutboundAffiliatesAPI.js